// 创新成长学院
import React, { Component } from 'react';
import { post } from '../utils/request';
import queryString from 'query-string';
import { wxShare, isWeChat, deleteUrlKey, getParameterByName } from '../utils/util';

// component
import Banner from '../components/banner';
import Login from '../components/login';
import Intro from '../components/intro'; // banner 底部活动介绍
import TopDom from '../components/top'; // 菜单
import Dialog from '../components/dialog';
import AttService from '../components/attentionService'; // 报名成功后关注服务号
import SignButton from '../components/signInButton'; // 右下角 立即报名 按钮
import CourseReCom from '../components/courseRecommend'; // 推荐课程
import { UserInfoClass } from '../components/groupPerson'; // 顶部用户基本信息
import { ProjectInfoClass } from '../components/groupProject';
import { OtherInfo } from '../components/groupOther';
import Investor from '../components/investor';

class Growth extends Component {
  constructor (props) {
    super(props);
    // 报名表信息
    this.state = {
      checkErr: false, // 检测表单数据
      hasLogin: false, // 默认没登录的情况下不会出现表单
      currentPageInfo: {}, // 页面基础信息
      endGetPage: false, // 页面基本信息获取完毕
      endGetUserInfo: false, // 页面表单信息获取完毕
      userInfo: {}, // 用户基本信息和项目信息
      showServiceDialog: false,// 展示服务号关注二维码
      wechatDialogJson: {}, // 服务号传送json
      commitFlag: true, // commit Flag
      subscribeProcess: '',
      userRole: 'entrepreneur', // TODO entrepreneur
      resInvestorData: {},
    }
    this.loginInfo = {      // login登录组件信息
      urlValues: '',
      userLoginInfo: {}
    }
    // 其他问题组件
    this.resApplyData = {
      answers: []
    };
  }
  componentDidMount () {
    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;
    this.loginInfo.urlValues = urlValues; // 传值给login组件
    this.getPageInfo();
    window.addEventListener('scroll', this.handelScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handelScroll);
  }
  handelScroll = () => {
    const t = document.documentElement.scrollTop || document.body.scrollTop;
    const top_view = document.getElementsByClassName('sign-fix-button')[0];
    const intro_view = document.getElementById('form-start');
    if (top_view && top_view !== null && intro_view && intro_view !== null) {
      top_view.style.display = t >= (intro_view.offsetTop - 500) ? 'none' : 'block';
    }
  }
  getPageInfo = () => {
    post('/fancube/apply/apply_info/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        // title rewrite
        if (res.data.apply_title) {
          document.title = res.data.apply_title
        }

        // add a question
        if (res.data && res.data.questions && res.data.define_sign_up.is_invite == 1) {
          let addRecommendList = [{
            id: 'recommend',
            name: "推荐人或推荐机构",
            holder: "如有请填写"
          }];

          if (res.data.questions && res.data.questions.length <= 0 ) {
            res.data.questions = addRecommendList;
          } else {
            res.data.questions = res.data.questions.concat(addRecommendList);
          }
        }

        // wechat share
        let wxDes = '';
        switch (res.data.type) {
          case '创新成长学院': wxDes = '小饭桌啊创新成长学院'; break; // todo update 
        }

        var _title =  res.data.define_sign_up.share_title || res.data.apply_title 
        var _desc =  res.data.define_sign_up.share_desc || wxDes

        this.wxTitle = _title
        this.wxDes = _desc

        wxShare(_title, _desc);

        // storage
        localStorage.removeItem('formPageSto');
        localStorage.setItem('formPageSto', JSON.stringify({
          banner: res.data.top_pc_banner,
          from: 'class',
          title: res.data.apply_title,
          shareUrl: deleteUrlKey('code'),
        }))

        var _amt = res.data.apply_member_type

        // 课程是否过期
        // 1. 第0届 永不过期
        // 2. 当前时间大于 举办时间 + 1 则为过期
        var _dateTomorrow = new Date(res.data.date);
        _dateTomorrow.setDate(_dateTomorrow.getDate() + 1);
        var _isout = res.data.number === 0 ? false : new Date() > _dateTomorrow 

        // change state
        this.setState({
          currentPageInfo: res.data,
          userRole: _amt == 2 ? 'investor' : 'entrepreneur',
          endGetPage: 'end',
          isCourseOut: _isout, 
          subscribeProcess: res.data.define_sign_up.subscribe_process,
        })
      }
    })
  }
  getUserInfo = (phone) => {
    post('/fancube/apply/v2/offline/en/', {
      "code": this.pageUrlValues.acid,
      "phone": phone
    })
    .then(res => {
      if (res.code === 200) {
        if (res.data.apply) {
          // 做添加问题处理
          if (res.data.apply.recommend) {
            let answersRecommendList = [{
              question: 'recommend',
              content: res.data.apply.recommend || '',
              answer_id: 'recommend_id'
            }];

            if (res.data.apply.answers && res.data.apply.answers.length > 0 ) {
              res.data.apply.answers = res.data.apply.answers.concat(answersRecommendList);
            } else {
              res.data.apply.answers = answersRecommendList;
            }
          }

          this.state.currentPageInfo["answers"] = res.data.apply.answers;
        }
 

        res.data.project.position = res.data.info.position

        var _investor = res.data.investor
        _investor.position = res.data.info.position
        _investor.organ = res.data.investor.organ || ''
        _investor.sectors = res.data.investor.sectors || []
        _investor.rounds = res.data.investor.rounds || []
   
        this.setState({
          userInfo: res.data,
          resInvestorData: _investor,
          currentPageInfo: this.state.currentPageInfo,
          endGetUserInfo: 'end',
          userRole: res.data.member_role || 'entrepreneur',
        });
      }
    })
  }
  getUserData = (resPonUserData) => {
    this.setState({
      resPonUserData
    })
  }
  getProjectData = (resProjectData) => {
    this.setState({
      resProjectData
    })
  }
  getApplyData = (resApplyData) => {
    this.resApplyData = resApplyData;
  }
  getLoginData = (resLoginData) => {
    this.resLoginData = resLoginData;
    this.setState({
      hasLogin: resLoginData.hasLogin,
      openId: resLoginData.openid
    }, () => {
      if (this.state.hasLogin) {
        // 登录成功后获取页面个人信息
        this.getUserInfo(resLoginData.userLoginInfo.phone);

        // 传参给服务号二维码组件
        let wechatDialogJson = {
          'code': this.pageUrlValues.acid
        }
        if (isWeChat() && this.state.openId ) {
          wechatDialogJson['openid'] = this.state.openId;
        }
        this.setState({
          wechatDialogJson: wechatDialogJson
        })

        let wxUrl = resLoginData.userLoginInfo.uid ? deleteUrlKey('code') + `&invite=${resLoginData.userLoginInfo.uid}` : '';

        if (isWeChat() && wxUrl) {
          wxShare(this.wxTitle, this.wxDes, wxUrl);
          // storage
          localStorage.removeItem('formPageSto');
          localStorage.setItem('formPageSto', JSON.stringify({
            banner: this.state.currentPageInfo.top_pc_banner,
            from: 'class',
            title: this.state.currentPageInfo.apply_title,
            shareUrl: wxUrl
          }))
        }
      }
    })
  }
  getAttService = (resAttService) => {
    this.setState({
      subscribe: resAttService.subscribe
    })
    if (resAttService.subscribe == 2) {
      this.gotoSuccessView()
    }
  }
  getInvestorData = (resInvestorData) => {
    this.state.resInvestorData = resInvestorData
  }
  gotoSuccessView = () => {
    // const { history } = this.props;
    // const location = { pathname: '/success?acid=' + this.pageUrlValues.acid,}
    // history.push(location);
    window.location =  '/form/success?acid=' + this.pageUrlValues.acid;
  }
  ajaxSubmitData = () => {
    var _isInvestor = this.state.userRole == 'investor'
    if (_isInvestor) {
      if (!(this.state.resPonUserData.isRight && this.state.resInvestorData.isRight && this.state.commitFlag)) return
      this.state.resPonUserData.position = this.state.resInvestorData.position;
    } else {
      if (!(this.state.resPonUserData.isRight && this.state.resProjectData.isRight && this.state.commitFlag)) return 
      this.state.resPonUserData.status = this.state.resProjectData.status;
      this.state.resPonUserData.position = this.state.resProjectData.position;
    }

    this.setState({
      commitFlag: false
    })

    let vendorVal = sessionStorage.getItem('UserVendor') && sessionStorage.getItem('UserVendor') !== null && sessionStorage.getItem('UserVendor') !== 'null' ? sessionStorage.getItem('UserVendor') : '';

    // 处理 recommend 问题
    let recommendAnswers = '';
    let commitAnswers = [];

    this.resApplyData.answers && this.resApplyData.answers.length > 0 && this.resApplyData.answers.forEach(tItem => {
      if (tItem.id === 'recommend') {
        recommendAnswers = tItem.content;
      } else {
        commitAnswers.push({
          id: tItem.id,
          name: tItem.name,
          content: tItem.content,
          question: tItem.id
        })
      }
    })

    let inviteVal = getParameterByName('invite') || '';
    let _member_role = this.state.userRole == 'onTheJob' ? 'entrepreneur' : this.state.userRole;

    var _params = {
      "member_role": _member_role,
      "project": _isInvestor ? '' : this.state.resProjectData,
      "info": this.state.resPonUserData,
      "entrepreneur": {
        "status": _isInvestor ? '' : this.state.resProjectData.status,
        "intro": this.state.resProjectData.entre_intro,
      },
      "investor": _isInvestor ? this.state.resInvestorData : '',
      "apply": {
        "answers": commitAnswers,
        "code": this.pageUrlValues.acid,
        "channel": this.pageUrlValues.channel,
        "recommend": recommendAnswers,
        "lesson_id": this.state.resPonUserData.lesson_id
      },
      "uid": this.resLoginData.userLoginInfo.uid,
      "invite": inviteVal,
      "vendor": vendorVal,
      "team_scale": this.state.resProjectData.team_scale,
    }

    post('/fancube/apply/v2/offline/submit/', _params).then(res => {
      this.setState({
        commitFlag: true
      })
      if (res.code === 200) {
        // fancube 设置可直接跳过
        if (this.state.subscribeProcess == 3) {
          this.gotoSuccessView(); return
        }
        // 没有关注服务号的情况
        if (!!!this.state.subscribe) {
          this.setState({
            showServiceDialog: true
          })
        }
        // 已经关注服务号
        else {
          this.gotoSuccessView()
        }
      }
    })

  }
  handleSubmit = () => {
    this.setState({
      checkErr: true
    })
    this.ajaxSubmitData();
  }
  render () {
    let changeJson = {};
    if (this.state.endGetUserInfo && this.state.userInfo.entrepreneur) {
      changeJson = {
        "position": this.state.userInfo.project.position,
        "status": this.state.userInfo.entrepreneur.status,
        "entre_intro": this.state.userInfo.entrepreneur.intro,
        "special_nostausbp": this.state.userInfo.entrepreneur && this.state.userInfo.entrepreneur.special_nostausbp
      };
    }
    return (
      <div className="class-wrapper page-wrapper">
        {
          this.state.endGetPage &&
          <div className="end-wrapper">
            <TopDom />
            <Banner url={this.state.currentPageInfo.top_pc_banner} />
            <Intro {...this.state.currentPageInfo} isShowValue={this.pageUrlValues} />
            <div id="form-start"></div>
            {
             this.state.isCourseOut ? <CourseReCom acid={ this.pageUrlValues.acid }/> : <Login {...this.loginInfo} type={this.state.currentPageInfo.type} receiveData={this.getLoginData} />
            }
            {
              this.state.hasLogin && this.state.endGetUserInfo &&
              <div className="form-info-wrapper">
                <div className="form-title">填写报名信息</div>
                {/* 个人信息 */}
                <UserInfoClass
                 { ...this.state.userInfo.info } 
                 checkErr={ this.state.checkErr } 
                 receiveData={ this.getUserData } 
                 receiveLogoutData={ this.getLoginData }/>
                {/* 项目信息 */}
                {
                  this.state.userRole == 'entrepreneur' && 
                  <ProjectInfoClass 
                    { ... this.state.userInfo.project} 
                    { ... changeJson } 
                    userRole = {this.state.userRole}
                    classType = {this.state.currentPageInfo.type}
                    checkErr={ this.state.checkErr } 
                    receiveData={ this.getProjectData } />
                }
                {/* 其它信息 */}
                {
                  this.state.currentPageInfo && 
                  this.state.currentPageInfo.questions && 
                  this.state.currentPageInfo.questions.length > 0 &&
                  <OtherInfo { ... this.state.currentPageInfo } 
                    receiveData={ this.getApplyData } />
                }
                <Dialog isShow={ this.state.showServiceDialog }>
                  <AttService receiveData={ this.getAttService } 
                    acid={ this.pageUrlValues.acid } 
                    isShowDia={ this.state.showServiceDialog } 
                    subscribeProcess={ this.state.subscribeProcess }  
                    history={ this.props.history } { ...this.state.wechatDialogJson } />
                </Dialog>
                { 
                  this.state.checkErr && 
                  (!this.state.resPonUserData.isRight 
                    || ( this.state.userRole == 'entrepreneur' && !this.state.resProjectData.isRight ) 
                    || ( this.state.userRole == 'investor' && !this.state.resInvestorData.isRight ) 
                    ) && 
                  <div className="err-bottom-tips">
                    请完善相关资料
                    {/* {!this.state.resPonUserData.isRight && <p> user data </p> }
                    {!this.state.resProjectData.isRight && <p> project data</p>}
                    {!this.state.resInvestorData.isRight && <p> investor data</p> } */}
                  </div>
                }
                <div className={this.state.commitFlag ? "submit-form l-button" : "submit-form l-button disabled"} 
                  onClick={ this.handleSubmit }>
                  {this.state.commitFlag ? '立即报名' : '正在提交...'}</div>
              </div>
            }
          </div>
        }
        { this.pageUrlValues && this.pageUrlValues.intro && 
          <SignButton scrollId="form-start" 
            isCourse={this.state.isCourseOut ? true : false}/> }
      </div>
    )
  }
}
export default Growth;
